"use client";

import styled from "styled-components";
import Sec01Bg from "/public/assets/images/company/vision/vision-bg-pc.png"
import Sec01BgMo from "/public/assets/images/company/vision/vision-bg-mo.png"
import GroupItem from "/public/assets/images/company/vision/group-item-pc02.png"
import GroupItemMo from "/public/assets/images/company/vision/spin-item-mo.png"
import GroupItemSec01 from "/public/assets/images/company/vision/mission-frame1.png"
import GroupItemSec02 from "/public/assets/images/company/vision/mission-frame2.png"
import GroupItemSec03 from "/public/assets/images/company/vision/mission-frame3.png"
import CoreItem01 from "/public/assets/images/company/vision/vision-swipe-01.png"
import CoreItem02 from "/public/assets/images/company/vision/vision-swipe-02.png"
import CoreItem03 from "/public/assets/images/company/vision/vision-swipe-03.png"
import ListIcon from "/public/assets/images/company/vision/vision-connect-ico02.png"
import {SIZES} from "@/components/constants";
import {useContext, useEffect, useRef, useState} from "react";
import {LayoutContext} from "@/app/ClientRootHomepage";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {getScroller, refreshOnAssetsReady, setupLenyStyle} from "@/app/homepage/utils";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import {useMediaQuery} from "react-responsive";

gsap.config({ force3D: false });
const Vision = () => {
    const { rootRef } = useContext(LayoutContext); // 공용 스크롤러
    const wrapRef = useRef(null);
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    useEffect(() => {
        const wrap = wrapRef.current;
        if (!wrap) return;

        const scroller = getScroller(rootRef);
        const contentEl =
            (scroller && scroller.querySelector && scroller.querySelector(".root")) ||
            (scroller && scroller.firstElementChild) ||
            scroller;

        const { cleanup } = setupLenyStyle({ wrap, scroller, contentEl });
        const titleEl = wrap.querySelector(".content-wrap .tit");

        const splitToChars = (el) => {
            if (!el) return [];
            const frag = document.createDocumentFragment();
            const walk = (node) => {
                if (node.nodeType === Node.TEXT_NODE) {
                    const text = node.textContent || "";
                    // for (const ch of text) frag.appendChild(makeSpan(ch));
                    for (const ch of text) {
                        const span = document.createElement("span");
                        if (ch === " ") {
                            span.className = "char is-space";
                            span.textContent = "\u00A0";
                        } else {
                            span.className = "char";
                            span.textContent = ch;
                        }
                        frag.appendChild(span);
                    }
                } else if (node.nodeType === Node.ELEMENT_NODE) {
                    if (node.tagName === "BR") {
                        frag.appendChild(node.cloneNode(true));
                    } else {
                        Array.from(node.childNodes).forEach(walk);
                    }
                }
            };

            const originals = Array.from(el.childNodes);
            originals.forEach(walk);
            el.innerHTML = "";
            el.appendChild(frag);
            return Array.from(el.querySelectorAll(".char"));
        };

        let tlTitle = null;
        let stTitle = null;

        if (titleEl) {
            titleEl.innerHTML =
                (!isTablet ? titleEl.dataset.pc : titleEl.dataset.mo) || "";
            const chars = splitToChars(titleEl);
            gsap.set(chars, {
                display: "inline-block",
                transformOrigin: "0% 100%",
                y: 24,
                opacity: 0,
            });

            tlTitle = gsap
                .timeline({ paused: true })
                .to(
                    chars,
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.6,
                        ease: "power3.out",
                        stagger: { each: 0.02, from: "start" },
                        force3D: false,
                    },
                    0
                )
                .to(
                    chars,
                    {
                        y: -4,
                        duration: 0.18,
                        ease: "sine.out",
                        stagger: { each: 0.02, from: "start" },
                        force3D: false,
                    },
                    ">-0.45"
                )
                .to(
                    chars,
                    {
                        y: 0,
                        duration: 0.18,
                        ease: "sine.in",
                        stagger: { each: 0.02, from: "start" },
                        force3D: false,
                    },
                    ">-0.12"
                );
            stTitle = ScrollTrigger.create({
                trigger: titleEl,
                start: "top 100%",
                end: "top 45%",
                scroller,
                toggleActions: "play none none reverse",
                onEnter: () => tlTitle && tlTitle.play(),
                onEnterBack: () => tlTitle && tlTitle.play(),
                onLeaveBack: () => tlTitle && tlTitle.reverse(),
            });
        }
        const contentSections = Array.from(wrap.querySelectorAll(".section-content"));
        const triggers = [];
        const tweenItems = [];

        contentSections.forEach((item) => {
            gsap.set(item, { opacity: 0, y: 30, willChange: "transform, opacity" });
            const tweenGsap = gsap.to(item, {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: "power2.out",
                paused: true,
                force3D: false,
            });
            const scrollGsap = ScrollTrigger.create({
                trigger: item,
                start: "top 70%",
                end: "top 45%",
                scroller,
                toggleActions: "play none none reverse",
                onEnter: () => tweenGsap.play(),
                onEnterBack: () => tweenGsap.play(),
                onLeaveBack: () => tweenGsap.reverse(),
            });
            tweenItems.push(tweenGsap);
            triggers.push(scrollGsap);
        });


        const offAssets = refreshOnAssetsReady(wrap);
        const onResize = () => ScrollTrigger.refresh();
        window.addEventListener("resize", onResize);
        return () => {
            triggers.forEach((st) => st.kill());
            tweenItems.forEach((tw) => tw.kill());
            if (stTitle) stTitle.kill();
            if (tlTitle) tlTitle.kill();
            if (titleEl) titleEl.innerHTML = "";
            window.removeEventListener("resize", onResize);
            offAssets && offAssets();
            cleanup();
        };
    }, [rootRef, isTablet]);

    const swiperRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [progressList, setProgressList] = useState(
        Array(CORE_SLIDES.length).fill(0)
    );
    useEffect(() => {
        setProgressList(Array(CORE_SLIDES.length).fill(0));
        setActiveIndex(0);
    }, []);

    useEffect(() => {
        let timer;
        timer = setInterval(() => {
            setProgressList((prev) =>
                prev.map((val, idx) => {
                    if (idx === activeIndex) {
                        if (val >= 100) return 100;
                        return val + 100 / (2000 / 50);
                    }
                    return val;
                })
            );
        }, 50);
        return () => clearInterval(timer);
    }, [activeIndex]);
    const handleSlideChange = (swiper) => {
        const realIndex = swiper.realIndex;
        const n = CORE_SLIDES.length;
        if (n === 0) return;
        const nextIdx = (activeIndex + 1) % n;
        const prevIdx = (activeIndex - 1 + n) % n;
        const isForward =
            realIndex === nextIdx || (activeIndex === n - 1 && realIndex === 0);
        const isBackward =
            realIndex === prevIdx || (activeIndex === 0 && realIndex === n - 1);

        setProgressList((prev) => {
            let updated = [...prev];
            if (activeIndex === n - 1 && realIndex === 0 && isForward) {
                updated = Array(n).fill(0);
            } else if (isForward) {
                updated[activeIndex] = 100;
            } else if (isBackward) {
                updated[activeIndex] = 0;
            }
            updated[realIndex] = 0;
            return updated;
        });
        setActiveIndex(realIndex);
    };
    const autoplayConfig = {
        delay: 2000,
        disableOnInteraction: false,
    }

    return(
        <VisionWrap ref={wrapRef}>
            <div className={"content-wrap sec01"}>
                <div
                    className={"tit"}
                    data-pc={`우리의 사명<br/> Mission`}
                />
                <div className={"content-wrap-visual-wrap-pc"}>
                    <div className={"content-wrap-visual"}>
                        <img src={Sec01Bg?.src} alt={"미션 배경"}/>
                    </div>
                    <div className={"section-content-wrap"}>
                        <div className={"section-content"}>
                            <img src={GroupItem?.src} alt={"미션 아이템"}/>
                        </div>
                    </div>
                </div>
                <div className={"content-wrap-visual-wrap-mo"}>
                    <div className={"visual-wrap-mo-bg"}>
                        <img src={Sec01BgMo?.src} alt={"미션 배경"}/>
                    </div>
                    <div className={"section-content-area"}>
                        <div className={"section-content-item-bg"}>
                            <div className={"section-content"}>
                                <img src={GroupItemMo?.src} alt={"미션 아이템"}/>
                            </div>
                        </div>
                        <div className={"section-content-item"}>
                            <div className={"section-content"}>
                                <img src={GroupItemSec01?.src} alt={"미션 아이템"}/>
                            </div>
                        </div>
                        <div className={"section-content-item"}>
                            <div className={"section-content"}>
                                <img src={GroupItemSec02?.src} alt={"미션 아이템"}/>
                            </div>
                        </div>
                        <div className={"section-content-item"}>
                            <div className={"section-content"}>
                                <img src={GroupItemSec03?.src} alt={"미션 아이템"}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"core-wrap"}>
                    <div className={"core-title"}>Core value</div>
                    <div className={"core-swipe-wrap-pc"}>
                        <Swiper
                            modules={[
                                Autoplay,
                                ...([Navigation]),
                            ]}
                            loop={true}
                            speed={800}
                            observer={true}
                            observeParents={true}
                            autoplay={autoplayConfig}
                            onSlideChange={handleSlideChange}
                            direction={"horizontal"}
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                        >
                            {CORE_SLIDES.map((slide, idx) => (
                                <SwiperSlide
                                    key={idx}
                                >
                                    <div className={"slide-items-wrap"}>
                                        <div className={"image-wrap"}>
                                            <img src={slide.img} alt={`slide-${idx}`}/>
                                        </div>
                                        <div className={"sub-cont"}>
                                            <div className={"title"}>{slide.information.title}</div>
                                            <div className={"desc"}>{slide.information.desc}</div>
                                            <div className={"list-wrap"}>
                                                {
                                                    slide.information.list.map((list, listIdx) =>
                                                        <div className={"list"} key={listIdx}>
                                                            <div className={"list-icon"}><img src={ListIcon?.src} /></div>{list.info}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className="progress-bar">
                            {CORE_SLIDES.map((_, idx) => (
                                <div key={idx} className="bar">
                                    <div
                                        className="fill"
                                        style={{width: `${progressList[idx]}%`}}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={"core-swipe-wrap-mo"}>
                        {
                            CORE_SLIDES.map((item, idx)=>
                                <div className={"wrap-mo-item section-content"} key={idx}>
                                    <div className={"mo-item-bg"}>
                                        <img src={item.img} alt={`slide-${idx}`}/>
                                    </div>
                                    <div className={"mo-item-info"}>
                                        <div className={"mo-item-title"}>
                                            {item.information.title}
                                        </div>
                                        <div className={"mo-item-desc"}>
                                            {item.information.desc}
                                        </div>
                                        <div className={"mo-item-list"}>
                                            {
                                                item.information.list.map((list, listIdx) =>
                                                    <div className={"list"} key={listIdx}>
                                                        <div className={"list-icon"}><img src={ListIcon?.src}/></div>
                                                        {list.info}
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </VisionWrap>
    )
}
const CORE_SLIDES = [
    {
        img: CoreItem01?.src,
        information: {
            title: "행복",
            desc: "내가 행복해야\n동료와 회사도 행복하다.",
            list: [
                {info: "출근시간, 미팅시간을 준수합니다."},
                {info: "야근을 조장하거나 퇴근 시 눈치주지 않습니다."},
                {info: "좋은 점을 발견 시 꼭 인정과 격려를 합니다."},
                {info: "Teams에서 1시간 안에 리턴콜과 피드백을 합니다."},
            ],
        }
    },
    {
        img: CoreItem02?.src,
        information: {
            title: "사람중심",
            desc: "나는 언제나 \n사람을 최우선으로 생각한다.",
            list: [
                {info: "배려와 존중의 언어를 사용합니다."},
                {info: "역지사지!\n타인과 협력시 상대방의 입장에서 생각합니다."},
                {info: "이름만 부르지 않고 직급으로 부릅니다."},
                {info: "여러 사람 앞에서 특정 대상을 타박하지 않습니다."},
            ],
        }
    },
    {
        img: CoreItem03?.src,
        information: {
            title: "동반성장",
            desc: "우리의 성장은 회사의 성장이 되고\n회사의 성장은 우리의 연봉으로 연결된다.",
            list: [
                {info: "함께 문제를 해결합니다."},
                {info: "서로간 약속을 잘 지킵니다."},
                {info: "협업에 적극 참여합니다."},
                {info: "의사결정이 났을때 \n투명성 있게 서로 정보를 공유합니다."},
            ],
        }
    },
]
const VisionWrap = styled.div`
    padding: 160px 0 105px;
    .content-wrap {
        .tit {
            font-weight: 700;
            font-size: 48px;
            line-height: 58px;
            letter-spacing: -0.02em;
            color: #4939B1;
            text-align: center;

            .char {
                display: inline-block;
            }

            .char.is-space {
                width: 0.3em;
            }
        }
        .content-wrap-visual-wrap-mo{
            display: none;
            position: relative;
            .section-content-area{
                position: absolute;
                top: 70px;
                left: 0;
                .section-content-item-bg{
                    margin-bottom: 60px;
                }
                .section-content-item{
                    padding: 0 16px;
                    & +.section-content-item{
                        margin-top: 24px;
                    }
                }
            }
        }
        .content-wrap-visual-wrap-pc{
            padding: 0 114px;
            margin-top: 80px;
            width: 100%;
            position: relative;
            .content-wrap-visual{
                border-radius: 20px;
                overflow: hidden;
        
            }
            .section-content-wrap{
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                padding: 0 196px;
            }
        }
        .core-wrap{
            width: 1280px;
            margin: 0 auto;
            padding-top: 120px;
            .core-title{
                text-align: center;
                font-weight: 700;
                font-size: 48px;
                line-height: 58px;
                letter-spacing: -0.02em;
                color: #23203B;
            }
            .core-swipe-wrap-pc{
                display: block;
                width: 100%;
                margin-top: 80px;
                position: relative;
                .slide-items-wrap{
                    display: flex;
                    height: 560px;
                    gap: 80px;
                    .image-wrap{
                        width: 560px;
                        flex-shrink: 0;
                        border-radius: 20px;
                        overflow: hidden;
                    }
                    .sub-cont{
                        flex: 0 0 auto;
                        .title{
                            margin-top: 40px;
                            color: #C0EB75;
                            font-size: 40px;
                            font-weight: 700;
                            line-height: 44px;
                            letter-spacing: -0.8px;
                        }
                        .desc{
                            margin-top: 40px;
                            font-size: 32px;
                            font-weight: 700;
                            line-height: 40px;
                            letter-spacing: -0.64px;
                            white-space: pre-line;
                        }
                        .list-wrap{
                            margin-top: 40px;
                            .list{
                                display: flex;
                                align-items: center;
                                gap: 8px;
                                font-size: 20px;
                                font-weight: 700;
                                line-height: 32px;
                                white-space: pre-line;
                                color: #666666;
                                .list-icon{
                                    width: 24px;
                                    height: 24px;
                                }
                                & + .list{
                                    margin-top: 14px;
                                }
                            }
                        }
                    }
                }
                .progress-bar{
                    position: absolute;
                    bottom: 0;
                    left: 640px;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    z-index: 20;
                    .bar{
                        width: 80px;
                        height: 2px;
                        background: rgba(0, 0, 0, 0.2);
                        overflow: hidden;
                        .fill{
                            height: 100%;
                            transition: width 0.05s linear;
                            background: #23203B
                        }
                    }
                }
            }
            .core-swipe-wrap-mo{
                display: none;
                padding: 0 16px;
                .wrap-mo-item{
                    .mo-item-bg{
                        border-radius: 20px;
                        overflow: hidden;
                    }
                    .mo-item-info{
                        margin-top: 32px;
                        .mo-item-title{
                            font-size: 32px;
                            font-weight: 700;
                            line-height: 48px;
                            letter-spacing: -0.64px;
                            color: #C0EB75;
                        }
                        .mo-item-desc{
                            font-size: 24px;
                            font-weight: 700;
                            line-height: 36px;
                            letter-spacing: -0.48px;
                            white-space: pre-line;
                            margin-top: 16px;
                        }
                        .mo-item-list{
                            margin-top: 16px;
                            .list{
                                display: flex;
                                align-items: center;
                                font-size: 14px;
                                font-weight: 700;
                                line-height: 22px;
                                color: #666;
                                gap: 4px;
                                .list-icon{
                                    width: 24px;
                                    height: 24px;
                                }
                                & + .list{
                                    margin-top: 16px;
                                }
                            }
                        }
                    }
                    & + .wrap-mo-item{
                        margin-top: 80px;
                    }
                }
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 20px 0 120px;
        .content-wrap {
            .tit {
                display: none;
            }
            .content-wrap-visual-wrap-pc{
                display: none;
            }
            .content-wrap-visual-wrap-mo{
                display: block;
            }
            .core-wrap{
                width: 100%;
                margin: 0 auto;
                padding-top: 80px;
                .core-title{
                    display: none;
                }
                .core-swipe-wrap-pc{
                    display: none;
                }
                .core-swipe-wrap-mo{
                    display: block;
                }
            }
        }
    }
`
export default Vision;